// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    MANUFACTURERS_REFRESH_FIRMWARE_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    manufacturersRefreshFirmwareResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* refreshFirmwares({ payload }) {
    try {

        let build = ['RELEASE', 'BETA'];
        let mutationRefresh = `mutation {`
        build.map((item, index) => {
            {
                mutationRefresh += `
                result${index}: refreshFirmwares(build: "${item}")
              `;
            }
        })
        mutationRefresh += `}`;

        let data = yield call(
            clientMutation,
            mutationRefresh,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result0) {
            yield put(manufacturersRefreshFirmwareResult({ refresh: true }))
        }

    } catch (exc) {
        yield put(manufacturersRefreshFirmwareResult({ refresh: false }))
        ExceptionManager(
            exc,
            "Manufacturers/.components/refreshFirmware/redux/saga",
            "refreshFirmwares"
        )
    }
}

function* watchMethods() {
    yield takeEvery(MANUFACTURERS_REFRESH_FIRMWARE_REQUEST, refreshFirmwares);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}